import { SliceCreator } from "@/features/vidyo-call/types/vidyo-common";

import { ChatMessage } from "../types/chat-message";

export interface ChatState {
  chat: {
    messages: ChatMessage[];
    hasUnreadMessages: boolean;
    hasNotificationPlayed: boolean;
    isChatEnabled: boolean;
    setIsChatEnabled: (isChatEnabled: boolean) => void;
    addMessage: (message: ChatMessage) => void;
    setHasNotificationPlayed: (hasNotificationPlayed: boolean) => void;
  };
}

export const createChatSlice: SliceCreator<keyof ChatState> = (set) => ({
  chat: {
    messages: [],
    hasUnreadMessages: false,
    hasNotificationPlayed: false,
    isChatEnabled: false,
    setIsChatEnabled: (isChatEnabled: boolean) => {
      set(
        (state) => {
          if (!isChatEnabled) {
            state.chatDrawer.isOpen = false;
            state.chat.hasUnreadMessages = false;
            state.chat.messages = [];
          }
          state.chat.isChatEnabled = isChatEnabled;
        },
        undefined,
        "chat/setIsChatEnabled",
      );
    },
    addMessage: (message) =>
      set(
        (state) => {
          state.chat.messages.push(message);
          if (message.participantId !== "You" && !state.chatDrawer.isOpen) {
            state.chat.hasUnreadMessages = true;
          }
        },
        undefined,
        "chat/addMessage",
      ),
    setHasNotificationPlayed: (hasNotificationPlayed: boolean) =>
      set(
        (state) => {
          state.chat.hasNotificationPlayed = hasNotificationPlayed;
        },
        undefined,
        "chat/setHasNotificationPlayed",
      ),
  },
});
